
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "createScenario",
      resolverType: "mutation",
      routePath: "/createScenario",
      httpMethod: "POST",
    });
  